/**
 * The available payment methods that a user can use to pay for their order.
 */
export enum PaymentMethodType {
    VISA = 'VISA',
    USUAL_CONDITIONS = 'COHAB',
    BIZUM = 'BIZUM',
    GOOGLE_PAY = 'GOOGLE_PAY',
    APPLE_PAY = 'APPLE_PAY',
    UNKNOWN = 'UNKNOWN'
}